<aside
  [attr.aria-label]="ariaLabel()"
  class="callout flex-container flex-dir-row"
  [ngClass]="[
    base() ? 'callout--' + base() : '',
    type() ? 'callout--' + type() : '',
    animation() ? 'no-animation' : '',
    paddingOrMarginAlteration() ? paddingOrMarginAlteration() : '',
    positioning() ? positioning() : '',
    error() ? 'callout--' + type() + '--error' : '',
    warning() ? 'callout--' + type() + '--warning' : '',
    success() ? 'callout--' + type() + '--success' : ''
  ]"
  data-test="mono-common-callout"
  [attr.id]="type() === 'info-text' ? 'ariaInputDescription' : null"
  [attr.role]="animation() !== 'no-animation' ? 'dialog' : null"
>
  <div *ngIf="!success() && !error() && !warning()" class="flex-container width-100">
    <svg class="icon icon--info-circle">
      <use xlink:href="#icon-info-circle" href="#icon-info-circle"></use>
    </svg>
    <p [innerHTML]="calloutText() | dontSanitizeHtml" class="align-self-middle"></p>
  </div>
  <div *ngIf="success()" class="flex-container align-middle align-center">
    <span>{{ calloutText() }}</span>
    <svg class="icon icon--checkmark">
      <use xlink:href="#icon-checkmark" href="#icon-checkmark"></use>
    </svg>
  </div>
  <div *ngIf="error()" class="flex-container flex-dir-column">
    <div class="flex-container align-justify">
      <span>{{ calloutText() }}</span>
      <svg class="icon icon--warning">
        <use xlink:href="#icon-warning" href="#icon-warning"></use>
      </svg>
    </div>
    <p *ngIf="errorDescription()" class="normal-text-weight padding-top-0-5">{{ errorDescription() }}</p>
  </div>
  <div *ngIf="warning()" class="flex-container flex-dir-column">
    <div class="flex-container align-justify">
      <h3>{{ calloutText() }}</h3>
    </div>
    <p *ngIf="warningDescription()" class="normal-text-weight padding-top-0-5">{{ warningDescription() }}</p>
  </div>
  <div class="flex-container callout__buttons">
    <ng-content select="[calloutButtons]"></ng-content>
  </div>
</aside>